var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatermarkDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1440 751",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 1469.39H396.657L726.128 1126.45L1055.81 1470H1418L725.546 749L37 1469.39Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.36 -518.388H1063.98L731.177 -172.229L398.122 -519H32.2197L731.765 208.768L1427.36 -518.388Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1672.41 1011.13V816.128L1339.78 469.751L1673 123.199V-68.6553L1490.7 -67.8248L973.666 470.363L1490.58 1005.88L1672.41 1011.13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-232.412 -68.6553V126.39L100.223 472.767L-233 819.319V1011.13L-50.6578 1010.34L466.377 472.155L-50.5318 -63.3661L-232.412 -68.6553Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatermarkDesktop);
export default __webpack_public_path__ + "static/media/watermark-desktop.bc7202bde528571f5c175ef0ec6d86b6.svg";
export { ForwardRef as ReactComponent };